import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageCrossText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPageCrossText"><Path d="M14.5 21.5H4.5V2.5H19.5V14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M21.3635 17.1213L19.2422 19.2426M17.1209 21.364L19.2422 19.2426M17.1209 17.1213L19.2422 19.2426M21.3635 21.364L19.2422 19.2426" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 6.5H15.5M8.5 10.5H11.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPageCrossText;
